import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorText, fmtTime } from "@/lib/api";

const LIVE = { headers: { "X-Doorman-Ledger": "live" } };

export const DisclosurePanel = () => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/disclosure").then((r) => setInfo(r.data)).catch((e) => toast.error(errorText(e))); }, []);

  const download = async () => {
    try {
      const r = await api.get("/admin/disclosure/file", { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = info.filename;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(errorText(e)); }
  };

  const record = async () => {
    setBusy(true);
    try { const r = await api.post("/admin/disclosure/record", null, LIVE); setInfo(r.data); toast.success("Recorded in your ledger and sent for Bitcoin anchoring"); }
    catch (e) { toast.error(errorText(e)); }
    setBusy(false);
  };

  if (!info) return null;
  const e = info.entry;
  return (
    <section className="max-w-3xl rounded-lg border border-[#222D3D] bg-[#0F141C] p-6 space-y-5" data-testid="disclosure-panel">
      <div>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-emerald-400">Private · owner only</p>
        <h2 className="mt-2 text-2xl font-semibold text-slate-50">Invention disclosure</h2>
        <p className="mt-2 text-sm text-slate-400">How the system works and its novel design aspects. Only the file's fingerprint goes into your ledger and onto Bitcoin, never the text.</p>
      </div>
      <div className="rounded-md border border-[#222D3D] bg-[#07090E] p-4 space-y-1">
        <p className="text-xs text-slate-500">SHA-256 fingerprint of {info.filename}</p>
        <p className="font-mono text-xs text-slate-200 break-all" data-testid="disclosure-sha256">{info.sha256}</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Button onClick={download} className="bg-emerald-500 hover:bg-emerald-400 text-[#07090E] font-semibold" data-testid="disclosure-download-btn"><Download className="h-4 w-4 mr-2" />Download PDF</Button>
        {!(e && e.anchor_seq) && (
          <Button onClick={record} disabled={busy} variant="outline" className="border-[#222D3D] bg-transparent" data-testid="disclosure-record-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><ShieldCheck className="h-4 w-4 mr-2" />Record in my ledger and anchor</>}
          </Button>
        )}
      </div>
      {e && (
        <p className="text-sm text-slate-300" data-testid="disclosure-entry-status">
          Ledger entry #{e.seq} · {fmtTime(e.arrived_at)} · {e.anchor_seq ? `Bitcoin anchor #${e.anchor_seq} (download its proof file in the Anchors tab)` : "not anchored yet"}
        </p>
      )}
    </section>
  );
};
